import { MotionPlayer } from '@af/design-system-docs-ui/motion-player';
import { Code } from '@atlaskit/code';
import SectionMessage from '@atlaskit/section-message';
import EasingCurves from "../../../../src/pages/foundations/motion/_components/_easing-curves";
import MotionProperties from "../../../../src/pages/foundations/motion/_components/_motion-properties";
import Transitions from "../../../../src/pages/foundations/motion/_components/_transitions";
import AvatarAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/avatar.json";
import InteractionAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/interaction.json";
import ContextAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/context.json";
import DropdownAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/dropdown.json";
import AccessibilityAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/accessibility.json";
import FunctionAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/function.json";
import SizeAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/size.json";
import StreamlinedAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/streamlined.json";
import doWorkflowFriction from "../../../../src/pages/foundations/motion/_assets/do-workflow-friction.png";
import dontWaitWithoutReason from "../../../../src/pages/foundations/motion/_assets/dont-wait-without-reason.png";
import doFocalPoint from "../../../../src/pages/foundations/motion/_assets/do-workflow-friction.png";
import dontCompetingAnimations from "../../../../src/pages/foundations/motion/_assets/dont-competing-animations.png";
import brandMoments from "../../../../src/pages/foundations/motion/_assets/brand-moments.png";
import * as React from 'react';
export default {
  MotionPlayer,
  Code,
  SectionMessage,
  EasingCurves,
  MotionProperties,
  Transitions,
  AvatarAnimation,
  InteractionAnimation,
  ContextAnimation,
  DropdownAnimation,
  AccessibilityAnimation,
  FunctionAnimation,
  SizeAnimation,
  StreamlinedAnimation,
  doWorkflowFriction,
  dontWaitWithoutReason,
  doFocalPoint,
  dontCompetingAnimations,
  brandMoments,
  React
};